import axios from 'axios';
import * as urls from './urlTypes';
import {
  toastError,
} from '../util/toastUtils';

export const uniAccess = async uniID => {
  const url = `${urls.API_GATEWAY_URL}/university/${uniID}`;
  try {
    const response = await axios({
      url,
      method: 'get',
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      return error.response.data;
    }
    toastError(error.message);
    return { message: 'Something went wrong, please contact support team.' };
  }
};


// export const saveUniversityUserDetail = async (uniID, fName, lName, emailAddr, uniRole) => {
//   // /api/insights/university/{universityshortname}/role
//   // {f_name: "A", l_name: "N", email_addr: "a@a.com", uni_role: "Student"}
//   const url = `${urls.API_GATEWAY_URL}/university/role/${uniID}`;
//   try {
//     const response = await axios({
//       url,
//       method: 'post',
//       withCredentials: true,
//       responseType: 'json',
//       data: {
//         f_name: fName,
//         l_name: lName,
//         email_addr: emailAddr,
//         uni_role: uniRole,
//       },
//     });
//     if (response.data.message === 'Role info saved.') {
//       return true;
//     }
//     return false;
//   } catch (error) {
//     console.warn(`University Role call failed: ${error}`);
//     // console.log(error.message);
//     toastError(error.message);
//     return false;
//   }
// };


export const getSimmonsBlogs = async () => {
  const url = urls.BLOG_URL;
  try {
    const response = await axios({
      url,
      method: 'get',
      responseType: 'json',
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    console.warn(`Blog API fails: ${error}`);
    return false;
  }
};
